import axios from 'axios';
const HOSTAPI = process.env.REACT_APP_BASE_URL;

export const EventFetchSlides = async (eventId: number) => {
    try {
        const response = await axios.get(`${HOSTAPI}/events/${eventId}/details`);
        if (response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error('Failed to fetch slides');
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
};
